<template>
  <div class="praise-box">
    <h4>{{ header }}</h4>

    <div class="praise-list">
      <div v-for="(item, i) in praises" :key="i" class="praise-item">
        <p class="praise">
          <span v-if="item.quotePrefix">“</span>
          <span v-html="item.quote"></span>
          <span v-if="item.quoteSuffix">”</span>
        </p>

        <p class="praise-footer">
          <span v-html="item.attribution"></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookPraise",
  props: {
    header: {
      type: String,
      default: "",
    },
    praises: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.praise-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 1em;
  flex-direction: column;
}

.praise-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.praise {
  font-size: 1.25em;
  padding-top: 1em;
  padding-bottom: 1em;
  box-sizing: border-box;
  text-align: center;
  margin: 0;
}

.praise-footer {
  font-size: 1.15em;
  padding-top: 0.25em;
  padding-bottom: 1em;
  box-sizing: border-box;
  text-align: center;
  margin: 0;
}
</style>
